export const imageCodes = {
    banner: {
        code: "${merchantId}_tmpl_img_33",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fmobile%20ban.png?alt=media&token=e04c201a-659c-46e3-97e4-33b94344014b",
    },

    banner_mob: {
        code: "${merchantId}_tmpl_img_34",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fmobile%20ban.png?alt=media&token=741a568b-111e-429f-bd52-1b3972c905ff",
    },

    slider: {
        code: "${merchantId}_tmpl_img_22",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fban.jpg?alt=media&token=4a1496e9-c38e-4175-ab10-3166ba5618a7",
    },

    slider1: {
        code: "${merchantId}_tmpl_img_30",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fban1.jpg?alt=media&token=a16b7821-798a-4a16-bb52-55c9937a0e4f",
    },

    slider2: {
        code: "${merchantId}_tmpl_img_31",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fban2.jpg?alt=media&token=cd6193ae-bcae-45e0-93d2-f107dfb50d8d",
    },
    
    ayesay: {
        code: "${merchantId}_tmpl_img_1",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fayesay.png?alt=media&token=cecce8a6-bc68-408e-aaee-18c46e975633",
    },

    ayesay1: {
        code: "${merchantId}_tmpl_img_2",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fayesay1.png?alt=media&token=888ca3be-efef-405e-b209-79db7dee2bf2",
    },

    ayesay2: {
        code: "${merchantId}_tmpl_img_3",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fayesay2.png?alt=media&token=5f4fe333-a851-4440-b861-f510e61e7674",
    },

    
    catego: {
        code: "${merchantId}_tmpl_img_16",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcat.png?alt=media&token=6f1b464d-24c5-473b-8264-345630f9d544",
    },

    catego1: {
        code: "${merchantId}_tmpl_img_17",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcat1.png?alt=media&token=af3b40a2-7402-4d03-8d69-bb996a4ca854",
    },

    catego2: {
        code: "${merchantId}_tmpl_img_18",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcat2.png?alt=media&token=a5047034-4d03-40ea-b5ef-4391d1c8aea6",
    },

    catego3: {
        code: "${merchantId}_tmpl_img_19",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcat3.png?alt=media&token=5eca8e76-1ee3-4160-bbea-485e9a9325c5",
    },

    catego4: {
        code: "${merchantId}_tmpl_img_20",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcat4.png?alt=media&token=00c98b6e-85e8-40be-b14a-8944e17daf07",
    },

    catego5: {
        code: "${merchantId}_tmpl_img_21",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcat5.png?alt=media&token=e9960cbb-9488-4a1e-9dac-3d7bdd847d2b",
    },


    items: {
        code: "${merchantId}_tmpl_img_6",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fb3.png?alt=media&token=53242b8a-86ee-4848-9af4-f1b9f7d96b45"
    },

    items1: {
        code: "${merchantId}_tmpl_img_7",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fb2.png?alt=media&token=a46a32e4-f154-4c1f-afcc-2425121afffe"
    },

    items2: {
        code: "${merchantId}_tmpl_img_8",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fb4.png?alt=media&token=7c16e7ba-8a68-4547-8d3b-9b41b28ba94e"
    },

    items3: {
        code: "${merchantId}_tmpl_img_9",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fb5.png?alt=media&token=9abf0928-fc17-4079-b183-e775a7b5efa6"
    },

    items4: {
        code: "${merchantId}_tmpl_img_10",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fb1.png?alt=media&token=f2ac3054-cc7b-43b0-9520-a4cc27c41308"
    },

    items5: {
        code: "${merchantId}_tmpl_img_23",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fb6.png?alt=media&token=a3e7547c-7abf-4c59-bb3d-ad8a7679b1a6"
    },

    hero: {
        code: "${merchantId}_tmpl_img_5",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fhero.png?alt=media&token=4b0c9da4-0e2a-4bd5-bc19-4c85b7daa5f7"
    },

    product: {
        code: "${merchantId}_tmpl_img_11",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fy2.jpg?alt=media&token=5f6a5659-cd3e-4c11-90e6-1f7b8e1ea621"
    },

    product1: {
        code: "${merchantId}_tmpl_img_12",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fy5.jpg?alt=media&token=9e4a58e7-71cf-4e74-a09e-9c9766def037"
    },

    product2: {
        code: "${merchantId}_tmpl_img_13",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fy4.jpg?alt=media&token=3ded0af8-4de3-42aa-8cf3-276311be6db8"
    },

    product3: {
        code: "${merchantId}_tmpl_img_14",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fy3.jpg?alt=media&token=78431bac-0b4d-406f-a32a-8f54de8684fd"
    },

    product4: {
        code: "${merchantId}_tmpl_img_29",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fy1.jpg?alt=media&token=ca3811e7-3dd8-4fe6-ae99-a3ba7afa081e"
    },

    
    hoodie: {
        code: "${merchantId}_tmpl_img_5",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fhoo.png?alt=media&token=c2a1b638-7ed0-4915-bec8-2ec9c58d548b"
    },

    hoodie1: {
        code: "${merchantId}_tmpl_img_4",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fhoo1.png?alt=media&token=fc41b430-359b-4025-a006-afb85f02c174"
    },

    hoodie2: {
        code: "${merchantId}_tmpl_img_15",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fhoo2.png?alt=media&token=a804d6c3-f29e-478e-b08d-bafd9392824b"
    },

    newArrival: {
        code: "${merchantId}_tmpl_img_39",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fiok.png?alt=media&token=6edd1e66-d05e-4116-91ea-6b50d900e6fc"
    },

    newArrival1: {
        code: "${merchantId}_tmpl_img_40",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fiok%201.png?alt=media&token=d769a468-343f-479e-98f9-06a819af57dd"
    },

    newArrival2: {
        code: "${merchantId}_tmpl_img_41",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fiok%202.png?alt=media&token=2bfb8090-3ed6-49ab-80d3-69ee0cb24458"
    },

    newArrival3: {
        code: "${merchantId}_tmpl_img_42",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fiok%203.png?alt=media&token=882427ff-0437-4342-a3e1-d7a4bf905f01"
    },

    newArrival4: {
        code: "${merchantId}_tmpl_img_43",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fiok%204.png?alt=media&token=7f37d12d-a064-42be-a38c-dfb04d494de5"
    },

    newArrival5: {
        code: "${merchantId}_tmpl_img_44",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fiok%205.png?alt=media&token=00ba04c6-a144-4e5a-854c-6f68dd0eb68d"
    },
}

export const videoCodes = {
    video1: {
        code: "${merchantId}_tmpl_video_1",
        video: "https://www.youtube.com/embed/3ci-o3IxuoQ"
    },

    video2: {
        code: "${merchantId}_tmpl_video_2",
        video: "https://www.youtube.com/embed/ncKvlu9oDR0"
    },

    video3: {
        code: "${merchantId}_tmpl_video_3",
        video: "https://www.youtube.com/embed/z_-TnNnodJo"
    }
}

export const textCodes = {
    text: {
        code: "${merchantId}_tmpl_text_1",
        text: "Big shout out to ko Aung Kyaw Win Ozznie for letting us use your baby 47 ronin and your studio.MadNest - Psycho Notorious"
    },

    shopNow: {
        code: "${merchantId}_tmpl_text_1",
        text: "S H O P N O W"
    },
}

export const titleCodes = {
    title1: {
        code: "${merchantId}_tmpl_title_1",
        title: "Aye Say Pal Collection"
    },

    title2: {
        code: "${merchantId}_tmpl_title_2",
        title: "Black Tribe"
    },

    title3: {
        code: "${merchantId}_tmpl_title_3",
        title: "MadNest - Psycho Notorious"
    },

    title4: {
        code: "${merchantId}_tmpl_title_4",
        title: "Madnest Bts with our Aung La Nsang(Burmese Python) shoot 🔪🎈"
    },

    title5: {
        code: "${merchantId}_tmpl_title_5",
        title: "Hightlight"
    },

    title6: {
        code: "${merchantId}_tmpl_title_6",
        title: "Best Seller Products"
    },

    title7: {
        code: "${merchantId}_tmpl_title_7",
        title: "Hoodie/Sweatshirt Collection"
    },

    title8: {
        code: "${merchantId}_tmpl_title_8",
        title: "Categories"
    },

    title9: {
        code: "${merchantId}_tmpl_title_10",
        title: "New Arrivals"
    },
}